export const OAUTH_API_URL = `https://api-dv.brightspeed.com/genai/oauth/token`;
const BASE_URL = 'https://api-dv.brightspeed.com/genai-studio/';
export const SUMMARY_API_URL = `${BASE_URL}api/v1/genai/summary`;
export const SALES_BOT_FAQS_API_URL = `${BASE_URL}sales_bot_faqs`;
export const FAQ_RAG_API_URL = `${BASE_URL}faq_rag/`;
export const FAQ_INSIGHT_CATEGORY_SEARCH_API_URL = `${BASE_URL}api/v1/admintool/genaifaqregistry`;
export const FAQ_INSIGHT_SMART_SEARCH_API_URL = `${BASE_URL}api/v1/admintool/genaifaqregistry/search`;
export const FEEDBACK_ADD_API_URL = `${BASE_URL}api/v1/admintool/feedback`;
export const UPDATE_FEEDBACK_API_URL = `${BASE_URL}api/v1/admintool/genaifaqhistory/updateFeedback`;
export const COMPETITOR_INFO_URL = `${BASE_URL}api/v1/admintool/compitetor/intelligence/`;
